<!-- Footer Block -->
<div class="page-footer text-center">
  <div class="row">
    <div class="col-md-12">&copy; {{currentYear}} {{"Lendisoft. All rights reserved"|translate}}.</div>
  </div>
</div>
